import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../reducers';

export const getDocumentGuid = createSelector(
  [
    (state: RootState): string | undefined => state.microweb.documentGuid,
    (state: RootState): string | undefined => state.refero.ui.dokumentGuid,
  ],
  (documentGuidMicroweb, documentGuidUi) => {
    return documentGuidMicroweb || documentGuidUi;
  }
);

export const getIsMicrowebStep = createSelector(
  [(state: RootState): boolean => state.microweb.isMicroweb, (state: RootState): boolean => state.microweb.isMicrowebStep],
  (isMicroweb, isMicrowebStep) => {
    return isMicroweb && isMicrowebStep;
  }
);
